import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { data } from 'jquery';


@Injectable({
  providedIn: 'root'
})
export class ApiService {
  contractTypeList() {
    throw new Error('Method not implemented.');
  }


  constructor(private httpService: HttpClient) {}

  private post(url, postData) {
    return this.httpService.post < any > (url, postData)
      .pipe(map(data => {
        return data;
      }));
  }

  getValidationStatus() {
    let validation = true
    return validation;
  }

  get(url, options = null) {
    if (options) {
      var headerOptions = this.setHeaderOptions(options);
    }
    return this.httpService.get < any > (url, headerOptions);
  }

  delete(url, id) {
    return this.httpService.delete(url + id);
  }

  signUp(data) {
    return this.post(`${environment.apiUrl}auths/create-employer`, data);
  }

  loginOtp(data) {
    return this.post(`${environment.apiUrl}auths/validate-otp`, data);
  }
  login(data) {
    return this.post(`${environment.apiUrl}accounts`, data);
  }
  postlogOut(data) {
    // return this.post(`${environment.apiUrl}accounts`, data);
  }
  linkBusiness(data) {
    return this.post(`${environment.apiUrl}employers/migrate-anpi`, data);
    //return this.get(`${environment.apilocalUrl}migrate-anpi.json`);
  }

  relinkBusiness(data) {
    return this.post(`${environment.apiUrl}employers/migrate-anpi`, data);
    //return this.get(`${environment.apilocalUrl}migrate-anpi.json`);
  }

  getAccountDetails() {
    return this.get(`${environment.apiUrl}accounts`);
  }
  employeeDetails(data) {
    return this.post(`${environment.apiUrl}employees/create-employee`, data);
  }
  employeesBulkUpload(data) {
    return this.post(`${environment.apiUrl}employees/bulk-upload`, data);
  }

  dependenceDetails(data) {
    return this.post(`${environment.apiUrl}employees/add-salary`, data);
  }
  getSalaryDetails(uuid) {
    return this.get(`${environment.apiUrl}employees/` + uuid);
  }
  getEmployeeSalaryRevise(uuid) {
    return this.get(`${environment.apiUrl}employees/salary-list/` + uuid);
    // return this.get(`${environment.apilocalUrl}salarylist.json`);
  }
  getEmployeeList(data?: any) {
    return this.get(`${environment.apiUrl}employees`, data);
  }
  getNotfication() {
    return this.get(`${environment.apiUrl}notifications`);
  }
  getFaqList() {
    return this.get(`${environment.apiUrl}faqs`);
  }
  getcnssReports() {
    return this.get(`${environment.apilocalUrl}data.json`);
  }
  bankDetails(data) {
    return this.post(`${environment.apiUrl}companies/bank-details-add`, data);
  }
  companyDetails(data) {
    return this.post(`${environment.apiUrl}companies/create-company`, data);
  }
  getCompanyDetails() {
    return this.get(`${environment.apiUrl}ccps/cnss-form-list`);
  }
  getCnamgsApprovalData() {
    return this.get(`${environment.apiUrl}cnamgs/cnamgs-form-list`);
  }

  getccpsCompanyDetails() {
    return this.get(`${environment.apiUrl}companies/company-details`);
  }
  getcnssResubmitData() {
    return this.get(`${environment.apiUrl}ccps/cnss-form-detail-list`);
  }

  cnssApprovalForm(data) {
    return this.post(`${environment.apiUrl}ccps/cnss`, data);
  }
  cnamgsApprovalForm(data) {
    return this.post(`${environment.apiUrl}cnamgs/cnamgs-create`, data);
  }
  contactDetails(data) {
    return this.post(`${environment.apiUrl}contacts`, data);
  }
  getDependenceDetails(id) {
    return this.get(`${environment.apiUrl}employees/list-nominie/` + id);
  }
  changePassword(data) {
    return this.post(`${environment.apiUrl}accounts/change-password`, data);
  }
  getCompanylist() {
    return this.get(`${environment.apiUrl}employees/employee-experiance`);
    // return this.get(`${environment.apilocalUrl}experience.json`);
  }
  getBanks() {
    console.log("125")
    return this.get(`${environment.apilocalUrl}bank.json`);
  }

  getEmployeeDetailswithccpsId(data) {
    return this.post(`${environment.apiUrl}ccps`, data);
  }
  getCnssReportonQuarter(data) {
    return this.post(`${environment.apiUrl}ccps/cnss-generate-report`, data);
    // return this.get(`${environment.apilocalUrl}cnss_report.json`);
  }

  viewCNSSHiringCertificate(data) {
    return this.post(`${environment.apiUrl}employees/generate-hiring-pdf`, data);
  }

  viewCnamgsHiringCertificate(data) {
    return this.post(`${environment.apiUrl}employees/generate-cnamgs-hiring-pdf`, data);
  }

  getCnamgsReportonQuarter(data) {
    return this.post(`${environment.apiUrl}cnamgs/cnamgs-generate-report`, data);
    // return this.get(`${environment.apilocalUrl}cnss_report.json`);
  }
  getcnamgsReportonQuarter(data) {
    return this.post(`${environment.apiUrl}cnamgs/cnamgs-generate-report`, data);
  }
  submitDependantsDetails(data) {
    return this.post(`${environment.apiUrl}employees/nominies`, data);
  }
  getBankList() {
    return this.get(`${environment.apiUrl}companies`); //bank list api
  }
  getidTypeList(data = null) {
    console.log(data);

    return this.get(`${environment.apiUrl}identity-types`, data);
  }
  getcontractTypeList() {
    return this.get(`${environment.apiUrl}employees/contract-type`);
  }
  getEducationLists() {
    return this.get(`${environment.apiUrl}employees/education-list`);
  }
  upload(data) {
    return this.post(`${environment.apiUrl}employees/upload`, data);
  }
  bankUpload(data) {
    return this.post(`${environment.apiUrl}companies/upload`, data);
  }
  updateEmployeewithID(data) {
    return this.post(`${environment.apiUrl}employees/employee-submit`, data);
  }
  resignEmployee(data) {
    return this.post(`${environment.apiUrl}employees/resignation`, data);
  }
  getCountryList() {
    return this.get(`${environment.apiUrl}countries`);
  }
  getRegionList() {
    return this.get(`${environment.apiUrl}regions`);
  }
  getEducationLevelList() {
    return this.get(`${environment.apiUrl}regions`);
  }
  getDistrictData() {
    return this.get(`${environment.apiUrl}districts`);
  }
  getDependantsList(id) {
    return this.get(`${environment.apiUrl}employees/employee-nominies/` + id);
  }
  getCityList(region) {
    return this.get(`${environment.apiUrl}cities/` + region);
  }
  getDistrictList(city) {
    return this.get(`${environment.apiUrl}districts/` + city);
  }

  // getNeighbourhoodList1(data) {
  //   return this.post(`${environment.apiUrl}neighborhoods`, data);
  // }
  getNeighbourhoodList1(data) {
    return this.post(`${environment.apiUrl}neighborhoods/neighborhood-list`, data);
  }
  getNeighbourhoodList() {
    return this.get(`${environment.apiUrl}neighborhoods`);
  }
  getCnssreportList(data) {
    return this.get(`${environment.apiUrl}ccps/cnss-list-report`, data);
  }

  
  getReportsbyID(id) {
    return this.get(`${environment.apiUrl}ccps-reports/cnss-report/` + id);
  }
  getCnamgsReportsbyID(id) {
    return this.get(`${environment.apiUrl}cnamgs/cnamgs-report-view/` + id);
  }

  salaryDetails(data) {
    return this.post(`${environment.apiUrl}employees/add-salary`, data);
  }
  submitCNSSreport(data) {
    return this.post(`${environment.apiUrl}ccps/cnss-submit-report`, data);
  }
  dependenceUpload(data) {
    return this.post(`${environment.apiUrl}employees/nominie-upload`, data);
  }
  payment(data) {
    return this.post(`${environment.apiUrl}ccps/payment`, data);
  }
  paymentCnamgs(data) {
    return this.post(`${environment.apiUrl}cnamgs/payment`, data);
  }
  getDependenceData(id) {
    return this.get(`${environment.apiUrl}employees/nominie-edit/` + id);
  }
  getReportlist() {
    return this.get(`${environment.apiUrl}employees/manage-cnss`);
    // return this.get(`${environment.apilocalUrl}cnsslist.json`)
  }
  getEmployeeCnamgsReportlist() {
    return this.get(`${environment.apiUrl}employees/manage-cnamgs`);
  }

  getCnssPdf() {
    return this.get(`${environment.apiUrl}ccps/cnss-report-export`);
  }
  resubmitReport(data) {
    return this.post(`${environment.apiUrl}ccps/cnss-resubmit-report`, data);
  }
  cnamgsResubmitReport(data) {
    return this.post(`${environment.apiUrl}cnamgs/cnamgs-report-resubmit`, data);
  }

  getRejectedEmployeeData(id) {
    return this.get(`${environment.apiUrl}employees/resubmit-employee/` + id);
  }
  employeeResubmit(data) {
    return this.post(`${environment.apiUrl}employees/employee-resubmit`, data);
  }
  forgotPassword(data) {
    return this.post(`${environment.apiUrl}auths/forgot-password`, data);
  }
  forgotOtp(data) {
    return this.post(`${environment.apiUrl}auths/forgot-validate-otp`, data);
  }
  resetPassword(data) {
    return this.post(`${environment.apiUrl}auths/reset-password`, data);
  }
  loginOtpResend(data) {
    return this.post(`${environment.apiUrl}auths/resend-account-otp`, data);
  }
  getBusinessList() {
    return this.get(`${environment.apiUrl}ccps/cnss-details-list`);
  }
  getBankLists() {
    return this.get(`${environment.apiUrl}companies/bank-details-list`);
  }
  deleteBankList(data) {
    return this.post(`${environment.apiUrl}companies/bank-delete`, data);
  }
  paymentInitiate(data) {
    return this.post(`${environment.apiUrl}ccps-reports/clikpay-initiate`, data);
  }
  paymetExecute(data) {
    return this.post(`${environment.apiUrl}ccps-reports/clikpay-execute`, data);
  }
  bankSlipUpload(data) {
    return this.post(`${environment.apiUrl}companies/upload`, data);
  }
  getcnamgsreportList(data) {
    return this.get(`${environment.apiUrl}cnamgs/cnamgs-list-report`, data);
  }
  getcnamgsPdf() {
    return this.get(`${environment.apiUrl}cnamgs/cnamgs-report-export`);
  }
  submitCnamgsreport(data) {
    return this.post(`${environment.apiUrl}cnamgs/cnamgs-submit-report`, data);
  }
  
  verificationCheckByQr(data) {
    return this.post(`${environment.apiUrl}auths/list-company-details`, data);
  }
  employeeVerificationCheckQr(data) {
    return this.post(`${environment.apiUrl}auths/list-employee-details`, data);
  }
  
  getEmployeeResignDetails(uuid) {
    return this.get(`${environment.apiUrl}employees/resigned-view/` + uuid);
  }
  getResignReasonLists() {
    return this.get(`${environment.apiUrl}employees/resigned-reason`);
  }
  // employeePasswordChange(data) {
  //   return this.post(`${environment.apiUrl}employees/password-reset`, data);
  // }
  employeePasswordChange(data) {
    return this.post(`${environment.apiUrl}accounts/set-password`, data);
  }
  deleteDependent(data) {
    return this.post(`${environment.apiUrl}employees/nominie-delete`, data);
  }
  changeLangauge(data) {
    return this.post(`${environment.apiUrl}accounts/language-selection`, data);
  }
  updateNotificationList(data) {
    return this.post(`${environment.apiUrl}notifications/notification-status-update`, data);
  }
  generateToken(data) {
    return this.post(`${environment.apiUrl}auths/token-generation`, data);
  }
  employeeEditBeforeSubmit(data) {
    return this.post(`${environment.apiUrl}employees/update-employee`, data);
  }

  getemployeeAllowance(data) {
    return this.post(`${environment.apiUrl}employee-allowances/generate-allowance`, data)
  }

  submitEmployeeAllowance(data) {
    return this.post(`${environment.apiUrl}employee-allowances/allowance-submit`, data)
  }

  getAllowanceList(data) {
    return this.get(`${environment.apiUrl}employee-allowances/allowance-list`, data)
  }

  getViewAllowanceReports(id) {
    return this.get(`${environment.apiUrl}employee-allowances/allowance-view/` + id)
  }

  submitEmployerAllowance(data) {
    return this.post(`${environment.apiUrl}employee-allowances/employer-submit-allowance`, data)
  }

  updateDp(data) {
    return this.post(`${environment.apiUrl}accounts/profile-update`, data)
  }

  employeeReportList(data) {
    return this.get(`${environment.apiUrl}employees/employee-report-list` , data)
  }

  cnssCalculate(data) {
    return this.post(`${environment.apiUrl}ccps/calculate`, data)
  }

  cnamgsCalculate(data) {
    return this.post(`${environment.apiUrl}cnamgs/calculate`, data)
  }

 

  cnssCnamgsStatusUpdate(data) {
    return this.post(`${environment.apiUrl}accounts/cnamgs-cnss-status`, data)
  }

  getDtsReportonQuarter(data) {
    return this.post(`${environment.apiUrl}ccps-reports/combined-generate-report`, data);
    // return this.get(`${environment.apilocalUrl}cnss_report.json`);
  }

  getDtsreportList(data) {
    return this.get(`${environment.apiUrl}ccps-reports/dts-list-report`, data);
  }

  submitDtsReport(data) {
    return this.post(`${environment.apiUrl}ccps-reports/combined-submit-report`, data);
  }

  dtsCalculate(data) {
    return this.post(`${environment.apiUrl}ccps-reports/combined-calculate`, data)
  }

  getDtsReportsbyID(id) {
    return this.get(`${environment.apiUrl}ccps-reports/combined-view-report` , id);
  }

  paymentInitiateDts(data) {
    return this.post(`${environment.apiUrl}ccps-reports/combined-clikpay-initiate`, data);
  }

  paymetExecuteDts(data) {
    return this.post(`${environment.apiUrl}ccps-reports/combined-clikpay-execute`, data);
  }

  invoiceVerificationCheckQr(data) {
    return this.post(`${environment.apiUrl}payment/payment-details`, data);
  }

  combinedBulkUploadReport(data) {
    return this.post(`${environment.apiUrl}ccps-reports/combined-bulk-upload-report`, data);
  }

  verifyNIF(data) {
    return this.post(`${environment.apiUrl}company-details/verify-user`, data);
  }

  verifyNIFOtp(data) {
    return this.post(`${environment.apiUrl}company-details/validate-company`, data);
  }

  uploadVerifyDocument(data) {
    return this.post(`${environment.apiUrl}company-details/upload`, data);
  }

  getCnssCnamgsDetails(data) {
    return this.get(`${environment.apiUrl}company-details/get-cnss-cnamgs`, data);
  }

  verifyCNSS(data) {
    return this.post(`${environment.apiUrl}dummy`, data);
  }

  getEmployerDetails(data) {
    return this.post(`${environment.apiUrl}company-details/get-company-details`, data);
  }

  verifyCNAMGS(data) {
    return this.post(`${environment.apiUrl}dummy`, data);
  }

  verifyManager(data) {
    return this.post(`${environment.apiUrl}company-details/create-company`, data);
  }
  getEmployeeData() {
    return this.get(`${environment.apilocalUrl}employee.json`);
  }
  getHiringData(data) {
    return this.post(`${environment.apiUrl}employee-hirings/save-hiring-details`, data);
  }
  getCnssData(data) {
    return this.post(`${environment.apiUrl}ccps/cnss-data`, data);
  }
  getCnamgsData(data) {
    return this.post(`${environment.apiUrl}cnamgs/cnamgs-data`, data);
  }
  getProfessionalRankList() {
    return this.get(`${environment.apiUrl}auths/professional-rank`);
  }
  getEmployeeTypeList() {
    return this.get(`${environment.apiUrl}auths/employee-type`);
  }
  getMaritalStatusList() {
    return this.get(`${environment.apiUrl}auths/marital-status`);
  }
  getProfessionalCategoryList() {
    return this.get(`${environment.apiUrl}auths/professional-category`);
  }
  getAffiliationTypeList() {
    return this.get(`${environment.apiUrl}auths/affiliation-type`);
  }
  getEmployeeCategoryList() {
    return this.get(`${environment.apiUrl}auths/employee-category`);
  }
  getAdministrativeStatusList() {
    return this.get(`${environment.apiUrl}auths/administrative-status`);
  }
  
  employeeHiring(data) {
    return this.post(`${environment.apiUrl}employee-hirings`, data);
  }
  employeeHiringDetails(data) {
    return this.post(`${environment.apiUrl}employee-hirings/details`, data);
  }
  employeeHiringDelete(data) {
    return this.post(`${environment.apiUrl}employee-hirings/employee-delete`, data);
  }

  VerifyOtpResend(data) {
    return this.post(`${environment.apiUrl}company-details/resend-otp`, data);
  }

  ValidateCnssNumber(data) {
    return this.post(`${environment.apiUrl}company-details/verify-cnss`, data);
  }

  setHeaderOptions(paramsArray) {
    let headers = new HttpHeaders();

    for (var key in paramsArray) {
      if (paramsArray.hasOwnProperty(key)) {
        headers = headers.append(key, paramsArray[key]);
      }
    }
    var headerArray = { headers };
    return headerArray;
  }

  getFormValidation(form) {
    Object.keys(form.controls).forEach(controlName => {
      form.get(controlName).setValidators(null);
      form.get(controlName).updateValueAndValidity();
    });
    return form;
  }




}
